import React from 'react';
import Faq from '../components/Faq';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import Hero1 from '../components/Hero1';
import Portfolio1 from '../components/Portfolio1';
import Promo from '../components/Promo';
import Services1 from '../components/Services4';
import CoreFeature from '../components/CoreFeature'; 
import Blog4 from '../components/Blog4';
import Sponsors2 from '../components/Sponsors2';
import VideoFeatrued from '../components/VideoFeatured';
import Services5 from '../components/Services5'; 
import VideoFeatruedTwo from '../components/VideoFeaturedTwo';
import Cta from '../components/Cta';
import TeamMembers2 from '../components/TeamMembers2';

function Home1() {
    return (
        <>
            <Header1 />             {/* Header */}
            <Hero1 />               {/* Hero Slides*/}
            <Promo />               {/* About Company */}
            <Blog4 />               {/* Our Services */}
            <Services1 />           {/* Manufacturing Capabilities */}
            <Sponsors2 />           {/* Industries - Our Fields of Services */}
            <VideoFeatrued />       {/* Core Features - Why Vedant Technology */}
            
            {/* <Services5 /> */}
            
            <TeamMembers2 />        {/* Our Vendors Network */}
            
            {/* <CoreFeature /> */}
            
            <VideoFeatruedTwo />    {/* Company Strength */}
            
            {/* <Cta /> */}
            {/* <Portfolio1 /> */}
            {/* <Pricing /> */}
            {/* <Analytics />
            <Subscribe />
            <Blog1 /> */}
            <Faq />
            <Cta/>
            <Footer1 />
        </>
    );
}

export default Home1;
